export { default } from "./personalInformationPage";
